// images...
import menuHome from "../images/menu-home.svg";
import menuHomeActive from "../images/menu-home-active.svg";
import menuEvents from "../images/menu-events.svg";
import menuEventsActive from "../images/menu-events-active.svg";
import menuAddEvent from "../images/add-green.svg";
import menuAddEventActive from "../images/menu-add-event-active.svg";
import menuExplore from "../images/menu-explre.svg";
import menuExploreActive from "../images/menu-explore-active.svg";
import menuAccount from "../images/menu-account.svg";
import menuAccountActive from "../images/menu-account-active.svg";
import menuUsers from "../images/menu-users.svg";
import menuUsersActive from "../images/menu-users-active.svg";
import menuFeedback from '../images/menu-feedback.svg';
import menuFeedbackActive from '../images/menu-feedback-active.svg';
import menuUpdates from '../images/menu-feedback.svg'; // TODO: заменить на отдельную иконку
import menuUpdatesActive from '../images/menu-feedback-active.svg'; // TODO: заменить на отдельную иконку
import menuArticles from '../images/menu-explre.svg'; // TODO: заменить на отдельную иконку (используем explore иконку)
import menuArticlesActive from '../images/menu-explore-active.svg'; // TODO: заменить на отдельную иконку (используем explore иконку)

// desktop
import menuEventsDesktop from "../images/desktop_events_icon.svg";
import menuEventsDesktopActive from "../images/desktop_events_icon_active.svg";
import menuAddEventDesktop from "../images/desktop_add_icon.svg";
import menuAddEventDesktopActive from "../images/desktop_add_icon_active.svg";
import menuExploreDesktop from "../images/desktop_explore_icon.svg";
import menuExploreDesktopActive from "../images/desktop_explore_icon_active.svg";
import menuPetsDesktop from "../images/desktop_pets_icon.svg";
import menuPetsDesktopActive from "../images/desktop_pets_icon_active.svg";
import menuUsersDesktop from "../images/menu-users-desktop.svg";
import menuUsersDesktopActive from "../images/menu-users-desktop-active.svg";
import menuFeedbackDesktop from '../images/menu-feedback-desktop.svg';
import menuFeedbackDesktopActive from '../images/menu-feedback-desktop-active.svg';
import menuUpdatesDesktop from '../images/menu-feedback-desktop.svg'; // TODO: заменить на отдельную иконку
import menuUpdatesDesktopActive from '../images/menu-feedback-desktop-active.svg'; // TODO: заменить на отдельную иконку
import menuArticlesDesktop from '../images/desktop_explore_icon.svg'; // TODO: заменить на отдельную иконку
import menuArticlesDesktopActive from '../images/desktop_explore_icon_active.svg'; // TODO: заменить на отдельную иконку

import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ensureNamespaces } from "../i18n";

/**
 * Возвращает локализованные пользовательские пункты меню.
 */
export function useUserMenuItems() {
  const { t, i18n } = useTranslation('menu');

  useEffect(() => {
    ensureNamespaces(['menu']);
  }, [i18n.language]);

  return [
    // { path: "/", label: t('footer.home'), ... } // если понадобится
    {
      path: "/",
      label: t('footer.home'),
      icon: { mobile: menuHome, desktop: menuEventsDesktop },
      activeIcon: { mobile: menuHomeActive, desktop: menuEventsDesktopActive },
    },
    {
      path: "/events",
      label: t('footer.events'),
      icon: { mobile: menuEvents, desktop: menuEventsDesktop },
      activeIcon: { mobile: menuEventsActive, desktop: menuEventsDesktopActive },
    },
    {
      path: "/add",
      label: t('footer.addEvent'),
      icon: { mobile: menuAddEvent, desktop: menuAddEventDesktop },
      activeIcon: { mobile: menuAddEventActive, desktop: menuAddEventDesktopActive },
      isCentral: { mobile: true, desktop: false },
    },
    {
      path: "/explore",
      label: t('footer.explore'),
      icon: { mobile: menuExplore, desktop: menuExploreDesktop },
      activeIcon: { mobile: menuExploreActive, desktop: menuExploreDesktopActive },
      
    },
    {
      path: "/profile",
      label: t('footer.pets'),
      icon: { mobile: menuAccount, desktop: menuPetsDesktop },
      activeIcon: { mobile: menuAccountActive, desktop: menuPetsDesktopActive },
    },
  ];
}

/**
 * Возвращает локализованные админские пункты меню.
 */
export function useAdminMenuItems() {
  const { t, i18n } = useTranslation('menu');

  useEffect(() => {
    ensureNamespaces(['menu']);
  }, [i18n.language]);

  return [
    {
      path: "/admin/users",
      label: t('admin.users'),
      icon: { mobile: menuUsers, desktop: menuUsersDesktop },
      activeIcon: { mobile: menuUsersActive, desktop: menuUsersDesktopActive },
    },
    {
      path: "/admin/feedback",
      label: t('admin.feedback'),
      icon: { mobile: menuFeedback, desktop: menuFeedbackDesktop },
      activeIcon: { mobile: menuFeedbackActive, desktop: menuFeedbackDesktopActive },
    },
    {
      path: "/admin/updates",
      label: t('admin.updates'),
      icon: { mobile: menuUpdates, desktop: menuUpdatesDesktop },
      activeIcon: { mobile: menuUpdatesActive, desktop: menuUpdatesDesktopActive },
    },
    {
      path: "/admin/articles",
      label: t('admin.articles'),
      icon: { mobile: menuArticles, desktop: menuArticlesDesktop },
      activeIcon: { mobile: menuArticlesActive, desktop: menuArticlesDesktopActive },
    },
    {
      path: "/admin/article-categories",
      label: t('admin.articleCategories'),
      icon: { mobile: menuArticles, desktop: menuArticlesDesktop },
      activeIcon: { mobile: menuArticlesActive, desktop: menuArticlesDesktopActive },
    },
    {
      path: "/admin/article-pet-tags",
      label: t('admin.articlePetTags'),
      icon: { mobile: menuArticles, desktop: menuArticlesDesktop },
      activeIcon: { mobile: menuArticlesActive, desktop: menuArticlesDesktopActive },
    },
    {
      path: "/admin/event-types",
      label: t('admin.eventTypes'),
      icon: { mobile: menuEvents, desktop: menuEventsDesktop },
      activeIcon: { mobile: menuEventsActive, desktop: menuEventsDesktopActive },
    },
    {
      path: "/admin/legal-pages",
      label: t('admin.legalPages'),
      icon: { mobile: menuArticles, desktop: menuArticlesDesktop },
      activeIcon: { mobile: menuArticlesActive, desktop: menuArticlesDesktopActive },
    },
    {
      path: "/admin/faq",
      label: t('admin.faq'),
      icon: { mobile: menuArticles, desktop: menuArticlesDesktop },
      activeIcon: { mobile: menuArticlesActive, desktop: menuArticlesDesktopActive },
    },
    {
      path: "/admin/dev-services",
      label: t('admin.devServices'),
      icon: { mobile: menuFeedback, desktop: menuFeedbackDesktop },
      activeIcon: { mobile: menuFeedbackActive, desktop: menuFeedbackDesktopActive },
    },
  ];
}

// для обратной совместимости (если где-то импортируются старые имена)
export const menuItemsHook = useUserMenuItems;
export default useUserMenuItems;

